import {get, post, Delete, put, upload } from './http'
// export const captchaCode = params => get('/QvTmGUMjdOzit', params);
export default {
	captchaCode(params){
		return get('/QvTmGUMjdOzit', params)
	},
	login(params){
		return get('/Login/login', params)
	}
}